import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
export const WHATSAPP_NUMBER = '5491153399780';
export const WHATSAPP_MESSAGE = 'Hola! Quiero saber más sobre El Botiquín Ancestral™.';
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;
type WhatsAppIconProps = {
  className?: string;
};
export function WhatsAppIcon({
  className = ''
}: WhatsAppIconProps) {
  return <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true" data-id="element-335" data-mp="1ef2g7tz1zzse">
      <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.87 9.87 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2Zm0 1.83c2.16 0 4.19.84 5.71 2.37a8.03 8.03 0 0 1 2.37 5.71c0 4.45-3.63 8.08-8.08 8.08a8.2 8.2 0 0 1-4.18-1.15l-.3-.18-3.11.82.83-3.04-.2-.31a8.02 8.02 0 0 1-1.23-4.29c0-4.45 3.62-8.08 8.09-8.08Zm-3.6 4.3c-.17 0-.45.06-.68.31-.24.25-.9.88-.9 2.15 0 1.26.92 2.48 1.05 2.65.13.17 1.79 2.83 4.4 3.87 2.17.86 2.61.69 3.08.65.47-.04 1.52-.62 1.74-1.23.21-.6.21-1.12.15-1.23-.06-.1-.24-.17-.5-.29-.25-.13-1.51-.75-1.75-.83-.23-.09-.4-.13-.57.12-.17.26-.65.83-.8 1-.15.17-.29.19-.55.06-.25-.13-1.07-.4-2.05-1.27a7.7 7.7 0 0 1-1.42-1.76c-.15-.26-.02-.4.11-.52.12-.12.26-.3.38-.46.13-.15.17-.26.26-.43.08-.17.04-.33-.02-.46-.06-.12-.57-1.38-.78-1.89-.2-.5-.41-.43-.57-.44h-.48Z" data-id="element-336" data-mp="19hk9894ljun1" />
    </svg>;
}
export function WhatsAppFloatingButton() {
  const reduceMotion = useReducedMotion();
  return <motion.a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" aria-label="Escribinos por WhatsApp" initial={reduceMotion ? false : {
    opacity: 0,
    scale: 0.9
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    duration: 0.3,
    delay: reduceMotion ? 0 : 1.2,
    ease: [0.22, 1, 0.36, 1]
  }} whileHover={reduceMotion ? undefined : {
    scale: 1.05
  }} whileTap={reduceMotion ? undefined : {
    scale: 0.96
  }} className="fixed bottom-4 right-4 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_26px_rgba(34,54,70,0.28)] transition-colors hover:bg-[#1EBE5B] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-forest md:bottom-7 md:right-7 md:h-16 md:w-16" data-id="element-337" data-mp="3qqugackbyrkc">
      <WhatsAppIcon className="h-7 w-7 md:h-8 md:w-8" data-id="element-338" data-mp="4aqk96k0ntz0" />
    </motion.a>;
}